// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"taggedMrSelector_checkbox__3XQlx","label":"taggedMrSelector_label__1eJO4"};